import { RainbowKitProvider } from '@rainbow-me/rainbowkit';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { WagmiConfig } from 'wagmi';
import { ThemeProvider } from '@mui/material/styles';
import { IConfiguration } from './createConfiguration';
import theme from './theme';

function withConfiguration<T extends JSX.IntrinsicAttributes>(
  config: IConfiguration,
  WrappedComponent: React.ComponentType<T>
) {
  const displayName =
    WrappedComponent.displayName || WrappedComponent.name || 'Component';

  const ComponentWithConfiguration = (props: T) => {
    return (
      <ThemeProvider theme={theme}>
        <WagmiConfig config={config.config}>
          <RainbowKitProvider chains={config.chains}>
            <SnackbarProvider
              style={{
                fontFamily: 'Barlow Condensed, sans-serif',
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}>
              <WrappedComponent {...(props as T)} />
            </SnackbarProvider>
          </RainbowKitProvider>
        </WagmiConfig>
      </ThemeProvider>
    );
  };

  ComponentWithConfiguration.displayName = `withConfiguration(${displayName})`;

  return ComponentWithConfiguration;
}

export default withConfiguration;
